import { useMutation, useQueryClient } from '@tanstack/react-query';

import { unblockUser } from '../api/usersApi';
import { ADMIN_USERS_QUERY_KEY } from './useAdminUsers';

// PARA-137, AC-2: инвалидирует ['admin','users'] после успешной разблокировки.
export function useUnblockUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId: number) => unblockUser(userId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_USERS_QUERY_KEY });
    },
  });
}
